import {useState, useEffect} from 'react';
import {getDoc, doc} from 'firebase/firestore';
import {db} from '../firebase-config';

const useFetchYears = () => {
    const [years, setYear] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchYear = async () => {
            try {
                const querySnapshot = await doc(db, "years", "ubSxV83pMcdoXr6OzCnN");
                const docSnap = await getDoc(querySnapshot);
                if(docSnap.exists()) {
                    setYear(docSnap.data().years);
                    setIsLoading(false);
                }
            } catch (err) {
                setError(err);
                setIsLoading(false);
            }
        };

        fetchYear();
    }, []);

    return {years, isLoading, error};
}
export default useFetchYears;